<template>
	<link-radio-group :value="p_value" @input="pl_input" :multiple="multiple" :itemWidth="itemWidth" :disabled="disabled">
		<link-radio v-for="item in lovs" :key="item.id" :label="item.name" :val="item.val" :width="itemWidth" :disabled="disabled"/>
	</link-radio-group>
</template>

<script>
    export default {
        name: "link-radio-lov",
        props: {
            value: {},                                                      //双向绑定值
            lovType: {required: true},                                      //值列表类型
            parentLovType: {},                                              //父值列表
            parentLovValue: {},                                             //父值列表类型
            excludeLov: {},                                                 //排除值列表
            disabledAutoSetDefault: {type: Boolean},                        //禁止自动设置默认值

            multiple: {type: Boolean},
            itemWidth: {},
            disabled: {type: Boolean}
        },
        watch: {
            lovType: {
                immediate: true,
                async handler() {
                    this.pl_reset()
                },
            },
            value: {
                immediate: true,
                handler(val) {
                    this.p_value = val
                },
            },
            parentLovType() {
                this.pl_reset()
            },
            parentLovValue() {
                this.pl_reset()
            },
        },
        data() {
            return {
                p_value: this.value,
                lovs: [],
            }
        },
        methods: {
            pl_input(val) {
                this.p_value = val
                this.$emit('input', val)
                this.$emit('change', val)
            },
            async pl_reset() {
                if (!this.lovType) return
                const {lovs, defaultVal} = await this.$lov.getLovData(this.lovType, this.parentLovType, this.parentLovValue, this.excludeLov, this.multiple)
                this.lovs = lovs || []
                if (!this.disabledAutoSetDefault && !this.p_value && !!defaultVal) this.pl_input(defaultVal)
            },
        }
    }
</script>

<style lang="scss">

</style>
